var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import platform from "../platform/index.js";
import utils from "../utils.js";
import AxiosError from "../core/AxiosError.js";
import composeSignals from "../helpers/composeSignals.js";
import { trackStream } from "../helpers/trackStream.js";
import AxiosHeaders from "../core/AxiosHeaders.js";
import { progressEventReducer, progressEventDecorator, asyncDecorator } from "../helpers/progressEventReducer.js";
import resolveConfig from "../helpers/resolveConfig.js";
import settle from "../core/settle.js";
var isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
var isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    (function (encoder) { return function (str) { return encoder.encode(str); }; })(new TextEncoder()) :
    function (str) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = Uint8Array.bind;
                return [4 /*yield*/, new Response(str).arrayBuffer()];
            case 1: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
        }
    }); }); });
var test = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    try {
        return !!fn.apply(void 0, __spreadArray([], __read(args), false));
    }
    catch (e) {
        return false;
    }
};
var supportsRequestStream = isReadableStreamSupported && test(function () {
    var duplexAccessed = false;
    var hasContentType = new Request(platform.origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex() {
            duplexAccessed = true;
            return 'half';
        },
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
var DEFAULT_CHUNK_SIZE = 64 * 1024;
var supportsResponseStream = isReadableStreamSupported &&
    test(function () { return utils.isReadableStream(new Response('').body); });
var resolvers = {
    stream: supportsResponseStream && (function (res) { return res.body; })
};
isFetchSupported && ((function (res) {
    ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(function (type) {
        !resolvers[type] && (resolvers[type] = utils.isFunction(res[type]) ? function (res) { return res[type](); } :
            function (_, config) {
                throw new AxiosError("Response type '".concat(type, "' is not supported"), AxiosError.ERR_NOT_SUPPORT, config);
            });
    });
})(new Response));
var getBodyLength = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var _request;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (body == null) {
                    return [2 /*return*/, 0];
                }
                if (utils.isBlob(body)) {
                    return [2 /*return*/, body.size];
                }
                if (!utils.isSpecCompliantForm(body)) return [3 /*break*/, 2];
                _request = new Request(platform.origin, {
                    method: 'POST',
                    body: body,
                });
                return [4 /*yield*/, _request.arrayBuffer()];
            case 1: return [2 /*return*/, (_a.sent()).byteLength];
            case 2:
                if (utils.isArrayBufferView(body) || utils.isArrayBuffer(body)) {
                    return [2 /*return*/, body.byteLength];
                }
                if (utils.isURLSearchParams(body)) {
                    body = body + '';
                }
                if (!utils.isString(body)) return [3 /*break*/, 4];
                return [4 /*yield*/, encodeText(body)];
            case 3: return [2 /*return*/, (_a.sent()).byteLength];
            case 4: return [2 /*return*/];
        }
    });
}); };
var resolveBodyLength = function (headers, body) { return __awaiter(void 0, void 0, void 0, function () {
    var length;
    return __generator(this, function (_a) {
        length = utils.toFiniteNumber(headers.getContentLength());
        return [2 /*return*/, length == null ? getBodyLength(body) : length];
    });
}); };
export default isFetchSupported && (function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _b, withCredentials, fetchOptions, composedSignal, request, unsubscribe, requestContentLength, _c, _request, contentTypeHeader, _d, onProgress, flush, isCredentialsSupported, response_1, isStreamResponse, options_1, responseContentLength, _e, onProgress, flush_1, responseData_1, err_1;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = resolveConfig(config), url = _a.url, method = _a.method, data = _a.data, signal = _a.signal, cancelToken = _a.cancelToken, timeout = _a.timeout, onDownloadProgress = _a.onDownloadProgress, onUploadProgress = _a.onUploadProgress, responseType = _a.responseType, headers = _a.headers, _b = _a.withCredentials, withCredentials = _b === void 0 ? 'same-origin' : _b, fetchOptions = _a.fetchOptions;
                responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
                unsubscribe = composedSignal && composedSignal.unsubscribe && (function () {
                    composedSignal.unsubscribe();
                });
                _f.label = 1;
            case 1:
                _f.trys.push([1, 7, , 8]);
                _c = onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head';
                if (!_c) return [3 /*break*/, 3];
                return [4 /*yield*/, resolveBodyLength(headers, data)];
            case 2:
                _c = (requestContentLength = _f.sent()) !== 0;
                _f.label = 3;
            case 3:
                if (_c) {
                    _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: "half"
                    });
                    contentTypeHeader = void 0;
                    if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
                        headers.setContentType(contentTypeHeader);
                    }
                    if (_request.body) {
                        _d = __read(progressEventDecorator(requestContentLength, progressEventReducer(asyncDecorator(onUploadProgress))), 2), onProgress = _d[0], flush = _d[1];
                        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
                    }
                }
                if (!utils.isString(withCredentials)) {
                    withCredentials = withCredentials ? 'include' : 'omit';
                }
                isCredentialsSupported = "credentials" in Request.prototype;
                request = new Request(url, __assign(__assign({}, fetchOptions), { signal: composedSignal, method: method.toUpperCase(), headers: headers.normalize().toJSON(), body: data, duplex: "half", credentials: isCredentialsSupported ? withCredentials : undefined }));
                return [4 /*yield*/, fetch(request)];
            case 4:
                response_1 = _f.sent();
                isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
                    options_1 = {};
                    ['status', 'statusText', 'headers'].forEach(function (prop) {
                        options_1[prop] = response_1[prop];
                    });
                    responseContentLength = utils.toFiniteNumber(response_1.headers.get('content-length'));
                    _e = __read(onDownloadProgress && progressEventDecorator(responseContentLength, progressEventReducer(asyncDecorator(onDownloadProgress), true)) || [], 2), onProgress = _e[0], flush_1 = _e[1];
                    response_1 = new Response(trackStream(response_1.body, DEFAULT_CHUNK_SIZE, onProgress, function () {
                        flush_1 && flush_1();
                        unsubscribe && unsubscribe();
                    }), options_1);
                }
                responseType = responseType || 'text';
                return [4 /*yield*/, resolvers[utils.findKey(resolvers, responseType) || 'text'](response_1, config)];
            case 5:
                responseData_1 = _f.sent();
                !isStreamResponse && unsubscribe && unsubscribe();
                return [4 /*yield*/, new Promise(function (resolve, reject) {
                        settle(resolve, reject, {
                            data: responseData_1,
                            headers: AxiosHeaders.from(response_1.headers),
                            status: response_1.status,
                            statusText: response_1.statusText,
                            config: config,
                            request: request
                        });
                    })];
            case 6: return [2 /*return*/, _f.sent()];
            case 7:
                err_1 = _f.sent();
                unsubscribe && unsubscribe();
                if (err_1 && err_1.name === 'TypeError' && /fetch/i.test(err_1.message)) {
                    throw Object.assign(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request), {
                        cause: err_1.cause || err_1
                    });
                }
                throw AxiosError.from(err_1, err_1 && err_1.code, config, request);
            case 8: return [2 /*return*/];
        }
    });
}); });
